import { z } from 'zod';
import { ANOMALY_STATUS_VALUES, ANOMALY_TYPE_VALUES } from '@fas/types';
import { isoDateSchema, paginationQuerySchema, uuidSchema } from './common';

// ── Anomaly detection (Phase 3F, ADR-061) ──────────────────────────────────────
export const listAnomaliesQuerySchema = paginationQuerySchema
  .extend({
    /** Default: OPEN; `ALL` lists every status. */
    status: z.enum([...ANOMALY_STATUS_VALUES, 'ALL']).default('OPEN'),
    type: z.enum(ANOMALY_TYPE_VALUES).optional(),
    facultyId: uuidSchema.optional(),
    departmentId: uuidSchema.optional(),
    collegeId: uuidSchema.optional(),
    /** Detected on or after / on or before (dates). */
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
  })
  .refine((v) => !v.from || !v.to || v.to >= v.from, { path: ['to'], message: 'Must be on or after the start date' });
export type ListAnomaliesQuery = z.infer<typeof listAnomaliesQuerySchema>;

/** Confirming or dismissing a finding needs a note: what was done, or why it is no issue. */
export const reviewAnomalySchema = z
  .object({
    note: z.string('A note is required').trim().min(5, 'Explain in at least 5 characters').max(1000),
  })
  .strict();
export type ReviewAnomalyInput = z.infer<typeof reviewAnomalySchema>;
